const tracksHR = {
    "view": {
        "table": {
            "title": "Uredi Pjesme",
            "column": {
                "name": "Ime",
                "mixName": "Ime Mixa",
                "mixLength": "Duljina Mixa",
                "player": "Player",
                "status": "Status",
                "accStatus": "Acc Status",
                "qc": "QC",
                "action": "Akcija"
            },
            "button": {
                "edit": "Uredi",
                "goToReleases": "Idi na Izdanja",
                "distribute": "Distribuiraj",
                "submitEditing": "Pošalji Uređivanje",
                "statusReady": "Spremno",
                "statusNotReady": "Nije Spremno"
            },
            "message": {
                "identityNotCheckedTooltip": "Još niste pružili sve svoje podatke, stoga ne možete distribuirati izdanja. Da biste to učinili, ljubazno Pošaljite Svoje Informacije.",
                "tracksNotReadyTooltip": "Molimo pošaljite metapodatke za sve pjesme kako biste distribuirali izdanje.",
                "tracksNotReadyForEditingTooltip": "Molimo pošaljite metapodatke za sve pjesme kako biste poslali uređivanja.",
                "distributionDisabledPreScanInProgressTooltip": "Molimo pričekajte da se pre-scan završi prije distribuiranja izdanja.",
                "distributionDisabledPreScanNotDoneTooltip": "Molimo izvršite pre-scan prije distribuiranja izdanja.",
                "distributionDisabledPreScanDeclarationNotSubmittedTooltip": "Molimo podnesite pre-scan deklaraciju prije distribuiranja izdanja.",
                "browserNotSupported": "Vaš preglednik ne podržava audio element.",
                "trackUpdated": "Pjesma je ažurirana!"
            },
            "modal": {
                "distribute": {
                    "header": "Jeste li sigurni da su svi uneseni podaci valjani i u potpunosti predstavljaju ovo izdanje?",
                    "body": {
                        "point1": "Nakon ove akcije, vaše izdanje će biti provjereno i ako su podaci točni, bit će distribuirano na službene i ekskluzivne datume distribucije.",
                        "point2": "Potvrđivanjem i prihvaćanjem ovog obrasca, u potpunosti prihvaćate i pridržavate se <1>Uvjeta Distribucije</1>, <3>Uvjeta Korištenja</3> i <5>Pravila Privatnosti</5>.",
                        "point3": "Potvrđivanjem i prihvaćanjem ovog obrasca, nesporno potvrđujete da podneseni sadržaj izdanja s pripadajućim sredstvima, audio datotekama i metapodacima, ili isključivo pripada vama ili je u potpunosti licenciran vašoj etiketi.",
                        "point4": "Ovim u potpunosti prihvaćate da ćete biti isključivo odgovorni za bilo kakve obmanjujuće informacije, nelicenciranu upotrebu, ilegalne aktivnosti ili bilo kakve sporove.",
                        "flaggedTracksTerms": {
                            "header": "Uvjeti za Označene Pjesme",
                            "point1": "Napomena: <strong>'{{releaseName}}'</strong> sadrži jednu ili više označenih pjesama, naknada od <strong>15 €</strong> po označenoj pjesmi primjenjuje se kako bi se izdanje dostavilo na <strong>Spotify</strong>. Budući da ste odlučili ne platiti ovu naknadu u ovom trenutku, izdanje neće biti dostavljeno na Spotify. Potvrđivanjem i prihvaćanjem ovog obrasca, priznajete i prihvaćate ove uvjete.",
                            "point2": "U budućnosti, ako odlučite da izdanje bude dostavljeno na <strong>Spotify</strong>, možete otići u odjeljak Označeno u tablici Izdanja i slijediti upute za plaćanje."
                        },
                        "artificialStreamingDeclaration": {
                            "header": "Izjava o Umjetnom Streamingu",
                            "point1": "<strong>1.</strong> Potpuno razumijem i slažem se da se neću upuštati u bilo koji oblik umjetnog streaminga, uključujući korištenje botova, streaming farmi ili bilo koje metode koja manipulira DSP metrima.",
                            "point2": "<strong>2.</strong> Neću plaćati niti nuditi plaćanje za plasman na playlistama, niti ću surađivati s bilo kojom trećom stranom koja obećava zajamčene plasmane — razumijem da se to smatra prijevarom i prevarom.",
                            "point3": "<strong>3.</strong> Priznajem da bilo kakve takve radnje mogu rezultirati trenutnim raskidom, gubitkom tantijema, pravnim zahtjevima, ugovornim kaznama i naknadama te prijavom DSP-ovima i vlastima.",
                            "point4": "<strong>4.</strong> Također jamčim da ću informirati i educirati bilo koje umjetnike ili klijente s kojima radim o ovim pravilima i osigurati da ih se pridržavaju.",
                            "point5": "<strong>5.</strong> Razumijem da ako se upustim u umjetni streaming, moji KYC podaci, uključujući moje puno ime, adresu, osobnu iskaznicu i druge osobne informacije, mogu biti podijeljeni s pravnim odjelima DSP-a, kao što su oni Spotifyja, Apple Musica i drugih.",
                            "point6": "<strong>6.</strong> Prihvaćam punu pravnu odgovornost za bilo kakva kršenja.",
                            "acknowledgment": "Ovim potvrđujem i slažem se pridržavati gore navedenih uvjeta o Umjetnom Streamingu, te prihvaćam punu pravnu odgovornost za bilo kakva kršenja."
                        }
                    },
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi i Prihvati"
                    }
                },
                "finishEditing": {
                    "header": "Jeste li sigurni da su svi uneseni podaci valjani i u potpunosti predstavljaju ovo izdanje?",
                    "body": {
                        "point1": "Nakon ove akcije, vaše izdanje će biti provjereno i ako su podaci točni, bit će ponovno distribuirano DSP partnerima. <strong>NAPOMENA, samo METAPODACI će biti poslani DSP-ovima, sadržaj kao što su SLIKE i AUDIO datoteke ne mogu se ažurirati na ovaj način.</strong>",
                        "point2": "Potvrđivanjem i prihvaćanjem ovog obrasca, u potpunosti prihvaćate i pridržavate se <1>Uvjeta Korištenja</1> i Uvjeta našeg Ekskluzivnog Ugovora o Distribuciji.",
                        "point3": "Potvrđivanjem i prihvaćanjem ovog obrasca, u potpunosti prihvaćate i pridržavate se <1>Pravila Privatnosti</1>.",
                        "point4": "Potvrđivanjem i prihvaćanjem ovog obrasca, nesporno potvrđujete da podneseni sadržaj izdanja s pripadajućim sredstvima, audio datotekama i metapodacima, ili isključivo pripada vama ili je u potpunosti licenciran vašoj etiketi.",
                        "point5": "Ovim u potpunosti prihvaćate da ćete biti isključivo odgovorni za bilo kakve obmanjujuće informacije, nelicenciranu upotrebu, ilegalne aktivnosti ili bilo kakve sporove."
                    },
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi i Prihvati"
                    }
                }
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "title": "Uredi pjesmu {{trackName}}",
                "mandatoryMetadata": "Obavezni Metapodaci",
                "required": "Obavezno",
                "trackName": "Ime Pjesme",
                "mixName": "Ime Mixa",
                "originalmix": "Originalni Mix",
                "remix": "Ovo je Remix ili Mix",
                "vocals": "Vokali",
                "genre": "Žanr",
                "subGenre": "Podžanr",
                "additionalMetadata": "Dodatni Metapodaci",
                "copyright": "Autorska Prava ©",
                "copyrightYear": "Godina Autorskih Prava",
                "albumOnly": "Samo Album",
                "explicitContent": "Eksplicitni Sadržaj",
                "isrc": "ISRC",
                "daIsrc": "Dolby Atmos ISRC",
                "generateIsrc": "Generiraj ISRC",
                "trackLanguageMetadata": "Metapodaci Jezika Pjesme",
                "language": "Jezik",
                "autoDetectLanguage": "Automatski Detektiraj (Jezik)",
                "accountingData": "Računovodstveni Podaci",
                "labelShare": "Udio Etikete (%)"
            },
            "placeholder": {
                "select": "Odaberi...",
                "labelShare": "npr. 50"
            },
            "help_text": {
                "trackName": "Naslov pjesme",
                "mixName": "Unesite ime mixa bez zagrada. Neke pjesme su izdane u više verzija. Ovo polje opisuje verziju, na primjer 'Bunte Bummler - Aesub (Monika Ross Remix)",
                "vocals": "Poslušajte svoju pjesmu u cijelosti. Ako vaša pjesma ima vokale, molimo odaberite jezik vokala. Ako je vaša pjesma bez vokala, odaberite opciju Instrumental. Dvaput provjerite kako biste bili sigurni. Ako je ovaj unos pogrešan, neke trgovine poput iTunesa i Apple Musica će odbiti izdanje.",
                "publishers": {
                    "publisherName": "<strong>Ime izdavača:</strong> Molimo unesite puno ime Izdavačke kuće ako koristite usluge izdavaštva.  Ako ne koristite službene usluge izdavaštva, molimo unesite/odaberite <strong>Copyright Control</strong>. Molimo <strong>ne unosite ime svoje etikete</strong> ako nije registrirana izdavačka kuća. Mogu se primijeniti pravne implikacije.",
                    "authorSongWriterName": "<strong>Puno ime autora / tekstopisca:</strong> Molimo unesite <strong>pravo ime i prezime</strong> osobe."
                },
                "contributors": {
                    "contributorsName": "<strong>Ime suradnika:</strong> Molimo unesite <strong>pravo ime i prezime</strong> osobe.",
                    "contributorsRoles": "<strong>Uloge suradnika:</strong> Najmanje jedan suradnik mora biti dodan kao <strong>Kompozitor</strong>. Ako vaša pjesma sadrži vokale, najmanje jedan suradnik mora biti dodan kao <strong>Kompozitor</strong> i jedan suradnik mora biti dodan kao <strong>Tekstopisac</strong>."
                },
                "copyright": "Ime nositelja autorskih prava",
                "albumOnly": "Označava hoće li se pjesma prodavati samo kao dio izdanja. Imajte na umu da neke trgovine mogu poništiti ovu uputu",
                "explicitContent": "Molimo označite ovo polje ako pjesma sadrži zabranjene stihove",
                "isrc": "Međunarodni standardni kod snimanja dodijeljen pjesmi. Ako nemate svoj, mi ćemo ga generirati za vas",
                "daIsrc": "Međunarodni standardni kod snimanja dodijeljen pjesmi. Ako nemate svoj, mi ćemo ga generirati za vas",
                "language": "Na kojem jeziku je napisan naziv pjesme? Molimo dvaput provjerite ako niste sigurni. Ako je ovaj unos pogrešan, neke trgovine poput iTunesa i Apple Musica će odbiti izdanje.",
                "labelShare": "<strong>Savjet:</strong> Industrijski standard za <strong>udio etikete</strong> je <strong>50%</strong> i <strong>50%</strong> za <strong>dioničare</strong>. Preporučujemo da unesete točan postotak udjela na koji ste se dogovorili s vašim umjetnicima, dioničarima i partnerima.",
                "costTypes": {
                    "point1": "Unesite samo stvarne, nastale ili unaprijed dogovorene <strong>troškove</strong> po pjesmi. Preporučujemo da ne unosite lažne troškove.",
                    "point2": "<strong>Vrste troškova</strong> mogu biti bilo koji fiksni ili varijabilni troškovi npr. <strong>Audio Mastering, Grafički Dizajn, Promocija, Marketing</strong> ili bilo koji drugi opravdani trošak potrošen za određenu <strong>pjesmu</strong> od strane <strong>Etikete</strong>."
                }
            },
            "button": {
                "submitTrack": "Pošalji Pjesmu"
            },
            "message": {
                "successArtistAdded": "Novi umjetnik je dodan!",
                "successPublisherAdded": "Novi izdavač je dodan!",
                "successContributorAdded": "Novi suradnik je dodan!",
                "successShareholderAdded": "Novi dioničar je dodan!",
                "successCostTypeAdded": "Nova vrsta troška je dodana!",
                "errorLabelShareInvalid": "Molimo unesite valjanu vrijednost (1-100)",
                "errorFormCannotBeSubmitted": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "accountingMetadata": {
                    "title": "UPOZORENJE",
                    "description": {
                        "point1": "OPCIONALNI METAPODACI - ispunite ovaj dio metapodataka samo ako ćete izdavati računovodstvene izvještaje svojim umjetnicima ili dioničarima!",
                        "point2": "Molimo osigurajte da su podaci podneseni u ovom odjeljku potpuno točni, jer će utjecati na izvještaje koje ćete slati svojim umjetnicima i dioničarima.",
                        "point3": "Preporučujemo dvostruku provjeru unosa jer nakon slanja, dodatno uređivanje i promjene nisu preporučene radi točnosti podataka.",
                        "point4": "Računovodstveni izvještaji za vaše umjetnike i dioničare imat će točan učinak samo ako ispravno podnesete sve parametre i prema vašim dogovorima s vašim umjetnicima i dioničarima.",
                        "point5": "Troškovi se mogu dodati samo jednom i ne mogu se uređivati kasnije zbog transparentnosti i točnosti. Provjerite jeste li točno unijeli sve troškove pjesme pri prvom pokušaju."
                    }
                }
            }
        }
    },
    "publishersRow": {
        "form": {
            "label": {
                "publishers": "Izdavači",
                "required": "Obavezno",
                "order": "Redoslijed",
                "publisherName": "Ime Izdavača",
                "authorSongWriterName": "Puno ime autora / tekstopisca"
            },
            "placeholder": {
                "publisherName": "Odaberi Izdavača..."
            },
            "button": {
                "addAnother": "Dodaj još jednog",
                "createNew": "Kreiraj novo?",
                "remove": "Ukloni"
            },
            "message": {
                "publisherRequired": "Molimo odaberite izdavača",
                "authorSongWriterRequired": "Molimo unesite pravo ime i prezime osobe."
            },
            "modal": {
                "header": "Dodaj novog Izdavača",
                "body": {
                    "label": {
                        "name": "Ime"
                    },
                    "message": {
                        "nameRequired": "Ime je obavezno",
                        "publisherAlreadyExists": "Izdavač već postoji"
                    }
                },
                "button": {
                    "createNew": "Kreiraj novo",
                    "cancel": "Otkaži"
                }
            }
        }
    },
    "contributorsRow": {
        "form": {
            "label": {
                "contributors": "Suradnici",
                "required": "Obavezno",
                "order": "Redoslijed",
                "contributorName": "Puno ime suradnika",
                "contributorRole": "Uloga suradnika"
            },
            "placeholder": {
                "contributorName": "Odaberi Suradnika..."
            },
            "button": {
                "addAnother": "Dodaj još jednog",
                "createNew": "Kreiraj novo?",
                "remove": "Ukloni"
            },
            "modal": {
                "header": "Dodaj novog Suradnika",
                "body": {
                    "label": {
                        "name": "Ime"
                    },
                    "help_text": {
                        "name": "Molimo unesite puno ime i prezime tekstopisca. Primjer: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Ime je obavezno",
                        "nameMustNotBeInUppercase": "Ime ne smije biti u svim velikim slovima",
                        "insertRealName": "Molimo unesite pravo ime i prezime osobe.",
                        "errorContributorAlreadyExists": "Suradnik već postoji"
                    }
                },
                "button": {
                    "createNew": "Kreiraj novo",
                    "cancel": "Otkaži"
                }
            }
        }
    },
    "shareholdersRow": {
        "form": {
            "label": {
                "order": "Redoslijed",
                "shareholders": "Dioničari",
                "shareholderName": "Ime Dioničara",
                "shareholderSplit": "Udio Dioničara (%)",
                "shareholderRoles": "Uloge Dioničara"
            },
            "placeholder": {
                "shareholderName": "Odaberi Dioničara...",
                "shareholderSplit": "npr. 50"
            },
            "message": {
                "shareholderRequired": "Molimo odaberite dioničara",
                "shareholderSplitRequired": "Molimo unesite valjanu vrijednost (1-100)",
                "shareholderRolesRequired": "Molimo odaberite barem jednu ulogu",
                "shareSum": "Udio Etikete i Udio Dioničara trebaju zbrojiti 100%"
            },
            "button": {
                "addAnother": "Dodaj još jednog",
                "createNew": "Kreiraj novo?",
                "remove": "Ukloni"
            },
            "modal": {
                "header": "Dodaj novog Dioničara",
                "body": {
                    "label": {
                        "name": "Ime",
                        "email": "Email"
                    },
                    "help_text": {
                        "name": "Molimo unesite puno ime i prezime tekstopisca. Primjer: 'Max Mustermann'"
                    },
                    "message": {
                        "nameRequired": "Ime je obavezno",
                        "emailRequired": "Email je obavezan",
                        "emailInvalid": "Email nije valjan"
                    }
                },
                "button": {
                    "createNew": "Kreiraj novo",
                    "cancel": "Otkaži"
                }
            }
        }
    },
    "costTypesRow": {
        "form": {
            "label": {
                "costTypes": "Vrste Troškova",
                "order": "Redoslijed",
                "costType": "Vrsta Troška",
                "cost": "Trošak (€)"
            },
            "placeholder": {
                "costType": "Odaberi Vrstu Troška...",
                "cost": "npr. -7.5"
            },
            "button": {
                "addAnother": "Dodaj još jedan",
                "createNew": "Kreiraj novo?",
                "remove": "Ukloni"
            },
            "message": {
                "costTypeRequired": "Molimo odaberite vrstu troška",
                "costNotNegative": "Molimo unesite negativnu vrijednost npr. -10.0"
            },
            "modal": {
                "header": "Dodaj Novu Vrstu Troška",
                "body": {
                    "label": {
                        "name": "Ime"
                    },
                    "message": {
                        "nameRequired": "Ime je obavezno",
                        "costTypeAlreadyExists": "Vrsta troška već postoji"
                    },
                    "button": {
                        "createNew": "Kreiraj novo",
                        "cancel": "Otkaži"
                    }
                }
            }
        }
    }
};

export default tracksHR;